import { useMe } from "./auth";

/** The date (YYYY-MM-DD) right now in a timezone. */
export function todayIn(timeZone: string, now: Date = new Date()): string {
  try {
    // en-CA formats dates as YYYY-MM-DD.
    return new Intl.DateTimeFormat("en-CA", { timeZone }).format(now);
  } catch {
    return new Intl.DateTimeFormat("en-CA").format(now);
  }
}

/**
 * Today in the user's timezone, worked out on the device. Changes always send this
 * explicit date (never "today"), so one that syncs hours later still lands on the right day.
 */
export function useToday(): string {
  const tz = useMe().data?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
  return todayIn(tz);
}
